// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"96dcf2f4","239":"891140a2","453":"97af8c7e","455":"4786f57b","977":"0a7b9e87"}[chunkId] + ".chunk.js";
};